module.exports = "/build/web/svg/images.d080fea1af0adcc212ce3b960fe8ebd4.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/images.svg
// module id = 169
// module chunks = 24